import {Component, EventEmitter, Input, Output} from '@angular/core';
import {UsuarioBc} from '../../model/usuario-bc';

@Component({
  selector: 'app-info-usuario',
  templateUrl: './info-usuario.component.html',
  styleUrls: ['./info-usuario.component.scss']
})
export class InfoUsuarioComponent {

  showAlert: boolean;
  @Input() corPrimaria: string;
  @Input() usuario: UsuarioBc;
  @Output() logout = new EventEmitter();

  constructor() {}

  primeiroNome(nomeCompleto: string): string {
    return nomeCompleto.split(' ')[0];
  }

  toggleAlert(confirm) {
    this.logout.emit(confirm);
    this.showAlert = !this.showAlert;
  }

  async sair() {
    this.showAlert = true;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/info-usuario/info-usuario.component.ts